import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3050';

function RegisterModal({ showNotification, setAuthView }) {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({ companyName: '', email: '', contactNumber: '', companyType: '', username: '', password: '', otp: '' });
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = e => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

    const handleSendOtp = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const res = await fetch(`${API_URL}/api/auth/send-otp`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: formData.email })
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message);
            showNotification('OTP sent to your email!', 'success');
            setStep(2);
        } catch (err) {
            showNotification(err.message || 'Failed to send OTP.', 'error');
        } finally {
            setIsLoading(false);
        }
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const registrationData = {
                companyName: formData.companyName,
                email: formData.email,
                contactNumber: formData.contactNumber,
                companyType: formData.companyType,
                username: formData.username,
                password: formData.password,
                otp: formData.otp
            };

            const res = await fetch(`${API_URL}/api/auth/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(registrationData)
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message);
            showNotification('Registration successful! Please log in.', 'success');
            setAuthView('login');
        } catch (err) {
            showNotification(err.message, 'error');
        } finally {
            setIsLoading(false);
        }
    };
    
    return (
        <div className="login-box">
            <div className="login-header">
                 <svg className="logo" viewBox="0 0 100 100"><path d="M 10,90 L 50,10 L 90,90 Z" fill="#fff" /><path d="M 30,90 L 50,50 L 70,90 Z" fill="#a78bfa" /></svg>
                <h2>Register Your Company</h2>
                <p>Create a new account for your business</p>
            </div>

            <form onSubmit={step === 1 ? handleSendOtp : handleRegister}>
                <div className="input-group">
                    <label>Company Name</label>
                    <input name="companyName" value={formData.companyName} onChange={handleChange} required disabled={isLoading || step === 2} />
                </div>
                 <div className="input-group">
                    <label>Company Type (e.g., Hardware, Factory)</label>
                    <input name="companyType" value={formData.companyType} onChange={handleChange} required disabled={isLoading || step === 2} />
                </div>
                <div className="input-group">
                    <label>Business Email</label>
                    <input name="email" type="email" value={formData.email} onChange={handleChange} required disabled={isLoading || step === 2} />
                </div>
                <div className="input-group">
                    <label>Contact Number</label>
                    <input name="contactNumber" value={formData.contactNumber} onChange={handleChange} required disabled={isLoading || step === 2} />
                </div>

                {step === 2 && (
                    <>
                        <hr className="form-divider" />
                         <div className="input-group">
                            <label>Admin Username</label>
                            <input name="username" value={formData.username} onChange={handleChange} required disabled={isLoading} />
                        </div>
                         <div className="input-group">
                            <label>Password</label>
                            <input name="password" type="password" value={formData.password} onChange={handleChange} required disabled={isLoading} />
                        </div>
                        <div className="input-group">
                            <label>Enter OTP from Email</label>
                            <input name="otp" placeholder="6-Digit OTP" value={formData.otp} onChange={handleChange} required disabled={isLoading} />
                        </div>
                    </>
                )}

                {step === 1 ? (
                    <button type="submit" className="login-button" disabled={isLoading}>{isLoading ? 'Sending...' : 'Send OTP'}</button>
                ) : (
                    <button type="submit" className="login-button" disabled={isLoading}>{isLoading ? 'Verifying & Registering...' : 'Complete Registration'}</button>
                )}
            </form>

            <div className="auth-switch">
                <p>Already have an account? <button onClick={() => setAuthView('login')}>Sign In</button></p>
            </div>
        </div>
    );
}

export default RegisterModal;
